var map = {
	"./avatar_dani": "./frontend/images/avatar_dani.jpg",
	"./avatar_dani.jpg": "./frontend/images/avatar_dani.jpg",
	"./favicon/android-chrome-192x192": "./frontend/images/favicon/android-chrome-192x192.png",
	"./favicon/android-chrome-192x192.png": "./frontend/images/favicon/android-chrome-192x192.png",
	"./favicon/android-chrome-512x512": "./frontend/images/favicon/android-chrome-512x512.png",
	"./favicon/android-chrome-512x512.png": "./frontend/images/favicon/android-chrome-512x512.png",
	"./favicon/apple-touch-icon": "./frontend/images/favicon/apple-touch-icon.png",
	"./favicon/apple-touch-icon.png": "./frontend/images/favicon/apple-touch-icon.png",
	"./favicon/favicon-16x16": "./frontend/images/favicon/favicon-16x16.png",
	"./favicon/favicon-16x16.png": "./frontend/images/favicon/favicon-16x16.png",
	"./favicon/favicon-32x32": "./frontend/images/favicon/favicon-32x32.png",
	"./favicon/favicon-32x32.png": "./frontend/images/favicon/favicon-32x32.png",
	"./favicon/favicon.ico": "./frontend/images/favicon/favicon.ico",
	"./favicon/mstile-150x150": "./frontend/images/favicon/mstile-150x150.png",
	"./favicon/mstile-150x150.png": "./frontend/images/favicon/mstile-150x150.png",
	"./favicon/safari-pinned-tab": "./frontend/images/favicon/safari-pinned-tab.svg",
	"./favicon/safari-pinned-tab.svg": "./frontend/images/favicon/safari-pinned-tab.svg",
	"./favicon_master": "./frontend/images/favicon_master.png",
	"./favicon_master.png": "./frontend/images/favicon_master.png",
	"./hero_image": "./frontend/images/hero_image.jpg",
	"./hero_image.jpg": "./frontend/images/hero_image.jpg",
	"./home/en/preview-1": "./frontend/images/home/en/preview-1.jpg",
	"./home/en/preview-1.jpg": "./frontend/images/home/en/preview-1.jpg",
	"./home/en/preview-2": "./frontend/images/home/en/preview-2.jpg",
	"./home/en/preview-2.jpg": "./frontend/images/home/en/preview-2.jpg",
	"./home/en/preview-3": "./frontend/images/home/en/preview-3.jpg",
	"./home/en/preview-3.jpg": "./frontend/images/home/en/preview-3.jpg",
	"./home/en/preview-4": "./frontend/images/home/en/preview-4.jpg",
	"./home/en/preview-4.jpg": "./frontend/images/home/en/preview-4.jpg",
	"./home/en/preview-5": "./frontend/images/home/en/preview-5.jpg",
	"./home/en/preview-5.jpg": "./frontend/images/home/en/preview-5.jpg",
	"./home/en/preview-6": "./frontend/images/home/en/preview-6.jpg",
	"./home/en/preview-6.jpg": "./frontend/images/home/en/preview-6.jpg",
	"./home/en/preview-7": "./frontend/images/home/en/preview-7.jpg",
	"./home/en/preview-7.jpg": "./frontend/images/home/en/preview-7.jpg",
	"./home/nl/preview-1": "./frontend/images/home/nl/preview-1.jpg",
	"./home/nl/preview-1.jpg": "./frontend/images/home/nl/preview-1.jpg",
	"./home/nl/preview-2": "./frontend/images/home/nl/preview-2.jpg",
	"./home/nl/preview-2.jpg": "./frontend/images/home/nl/preview-2.jpg",
	"./home/nl/preview-3": "./frontend/images/home/nl/preview-3.jpg",
	"./home/nl/preview-3.jpg": "./frontend/images/home/nl/preview-3.jpg",
	"./home/nl/preview-4": "./frontend/images/home/nl/preview-4.jpg",
	"./home/nl/preview-4.jpg": "./frontend/images/home/nl/preview-4.jpg",
	"./home/nl/preview-5": "./frontend/images/home/nl/preview-5.jpg",
	"./home/nl/preview-5.jpg": "./frontend/images/home/nl/preview-5.jpg",
	"./home/nl/preview-6": "./frontend/images/home/nl/preview-6.jpg",
	"./home/nl/preview-6.jpg": "./frontend/images/home/nl/preview-6.jpg",
	"./home/nl/preview-7": "./frontend/images/home/nl/preview-7.jpg",
	"./home/nl/preview-7.jpg": "./frontend/images/home/nl/preview-7.jpg",
	"./icons/icon_192": "./frontend/images/icons/icon_192.png",
	"./icons/icon_192.png": "./frontend/images/icons/icon_192.png",
	"./icons/icon_512": "./frontend/images/icons/icon_512.png",
	"./icons/icon_512.png": "./frontend/images/icons/icon_512.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./frontend/images sync recursive ^\\.\\/.*$";